import { useContext } from 'react';

import { I18nContext, type TranslationParams } from './i18n-context';
import { esMessages } from './messages';

const fallback = {
  language: 'es' as const,
  locale: 'es-US' as const,
  setLanguage: () => Promise.resolve(),
  t: (key: keyof typeof esMessages, params: TranslationParams = {}) =>
    esMessages[key].replaceAll(/\{(\w+)\}/gu, (_match, name: string) => String(params[name] ?? '')),
};

export function useI18n() {
  return useContext(I18nContext) ?? fallback;
}
